/* OCB relaunch: homepage section behavior. Works per section instance and re-inits in the theme editor. */
(function () {
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  document.documentElement.classList.add('ocbh-js');

  function spans(ms) {
    var set = {}; ms.forEach(function (m) { set[m] = true; });
    if (ms.length >= 12) return [[0, 12]];
    var runs = [];
    for (var i = 0; i < 12; i++) {
      if (set[i] && !set[(i + 11) % 12]) { var l = 0; while (set[(i + l) % 12] && l < 12) l++; runs.push([i, l]); }
    }
    var out = [];
    runs.forEach(function (r) { if (r[0] + r[1] <= 12) out.push(r); else { out.push([r[0], 12 - r[0]]); out.push([0, r[0] + r[1] - 12]); } });
    return out;
  }

  function initCalendar(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var crops = [].map.call(root.querySelectorAll('[data-crop]'), function (el) {
      return { name: el.dataset.crop, months: el.dataset.months.split(',').map(function (x) { return parseInt(x, 10) - 1; }).filter(function (x) { return x >= 0 && x < 12; }) };
    });
    var monthsEl = root.querySelector('.ocbh-cal__months'), cropsEl = root.querySelector('[data-crops]'), nowEl = root.querySelector('[data-now]');
    var sel = new Date().getMonth();
    MONTHS.forEach(function (m, i) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = m;
      b.addEventListener('click', function () { sel = i; render(); });
      monthsEl.appendChild(b);
    });
    function render() {
      [].forEach.call(monthsEl.querySelectorAll('button'), function (b, i) { b.setAttribute('aria-pressed', i === sel); });
      cropsEl.innerHTML = ''; var inSeason = [];
      crops.forEach(function (c) {
        var on = c.months.indexOf(sel) > -1;
        var row = document.createElement('div'); row.className = 'ocbh-cal__crop' + (on ? ' on' : '');
        var cur = document.createElement('div'); cur.className = 'ocbh-cal__cur'; cur.style.gridColumn = (sel + 2) + '/' + (sel + 3); row.appendChild(cur);
        var n = document.createElement('div'); n.className = 'ocbh-cal__name'; n.textContent = c.name; row.appendChild(n);
        spans(c.months).forEach(function (r) { var b = document.createElement('div'); b.className = 'ocbh-cal__bar'; b.style.gridColumn = (r[0] + 2) + '/span ' + r[1]; row.appendChild(b); });
        cropsEl.appendChild(row); if (on) inSeason.push(c.name);
      });
      nowEl.innerHTML = '<span class="lbl">In season in ' + MONTHS[sel] + ':</span>' +
        (inSeason.length ? inSeason.map(function (x) { return '<span class="chip">' + x.replace(/</g, '&lt;') + '</span>'; }).join('') : '<span class="lbl">Between harvests</span>');
    }
    render();
  }

  function initSlider(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var input = root.querySelector('input[type=range]'), jars = [].slice.call(root.querySelectorAll('[data-jar]'));
    var shelf = root.querySelector('.ocbh-shelf'), name = root.querySelector('[data-pick-name]'), note = root.querySelector('[data-pick-note]'), link = root.querySelector('[data-pick-link]');
    if (!input || !jars.length) return;
    function select(i, scroll) {
      jars.forEach(function (j, k) { j.classList.toggle('is-on', k === i); });
      var j = jars[i];
      if (name) name.textContent = j.dataset.name;
      if (note) note.textContent = j.dataset.note;
      if (link) link.href = j.href;
      if (scroll && shelf && shelf.scrollWidth > shelf.clientWidth) shelf.scrollTo({ left: j.offsetLeft - (shelf.clientWidth - j.offsetWidth) / 2, behavior: 'smooth' });
    }
    input.addEventListener('input', function () { select(parseInt(input.value, 10), true); });
    jars.forEach(function (j, k) {
      j.addEventListener('mouseenter', function () { input.value = k; select(k, false); });
      j.addEventListener('focus', function () { input.value = k; select(k, false); });
    });
    select(Math.min(parseInt(input.value, 10) || 0, jars.length - 1), false);
  }

  function initBest(grid) {
    if (grid.dataset.ready) return; grid.dataset.ready = '1';
    var n = parseInt(grid.dataset.ocbBest, 10) || 4;
    fetch('/collections/all?sort_by=best-selling&view=ocbbest', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var box = document.createElement('div'); box.innerHTML = html;
        var items = [].slice.call(box.querySelectorAll('[data-item]')).slice(0, n);
        if (items.length < Math.min(3, n)) return; // keep the hand-picked fallback
        [].forEach.call(grid.querySelectorAll('[data-item]'), function (el) { el.remove(); });
        items.forEach(function (el) { grid.appendChild(el); });
        document.dispatchEvent(new CustomEvent('ocb:best-loaded'));
      }).catch(function () {});
  }

  function initCarousel(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('.ocbh-carousel');
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.5, behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.5, behavior: 'smooth' }); });
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.ocbh-reveal:not(.in)');
    if (!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode) { [].forEach.call(els, function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });
    [].forEach.call(els, function (e) { io.observe(e); });
  }

  function initAll(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-ocbh-calendar]'), initCalendar);
    [].forEach.call(scope.querySelectorAll('[data-ocbh-slider]'), initSlider);
    [].forEach.call(scope.querySelectorAll('[data-ocb-best]'), initBest);
    [].forEach.call(scope.querySelectorAll('[data-ocbh-carousel]'), initCarousel);
    initReveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
